<template>
    <div class="app">
        <b-navbar toggleable="lg" type="dark" class="bgtopbar" fixed="top">
            <b-navbar-brand href="#">
                <b-icon icon="diamond-half"></b-icon>   {{$t('HomePage.appname')}}
            </b-navbar-brand>
            <b-col align-h="center" class="title">
                {{ $route.query.desc }} 
            </b-col>
    
            <b-navbar-nav class="ml-auto">
    
                <b-nav-item-dropdown text="Lang" right>
                    <b-dropdown-item href="#" @click.prevent="lang_en">EN</b-dropdown-item>
                    <b-dropdown-item href="#" @click.prevent="lang_la">LA</b-dropdown-item>
    
                </b-nav-item-dropdown>
    
                <!-- <b-nav-item-dropdown right>
                           
                            <template #button-content>
                                <em>User</em>
</template>
                        <b-dropdown-item href="#">Profile</b-dropdown-item>
                        <b-dropdown-item href="#">Sign Out</b-dropdown-item>
                    </b-nav-item-dropdown> -->
                </b-navbar-nav>
        </b-navbar>
        <div class="text-center" style="text-align: center;">
            <!-- <img class="images" src="../assets/logo.png" alt=""   srcset="" height="5%" width="5%" />
     -->
        </div>
        
        <div class="root mt-5 ">
            <b-card class="text-center mb-2 " :header="$t('LoginPage.title') ">
                
                <b-card-text>
                    <b-row>
                        <b-col>
    
                            <b-form-input class="p-3" id="input-large" size="lg" v-model="user.username" :placeholder="$t('LoginPage.username')"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
    
                            <b-form-input class="p-3" type="password" id="input-large" v-model="user.password" size="lg" :placeholder="$t('LoginPage.password')"></b-form-input>
                        </b-col>
                    </b-row>
                    <br />
                    <b-button block variant="primary" v-on:click="onLogin()"> {{$t('LoginPage.btnlogin')}} </b-button>
                </b-card-text>
                <b-alert :show="dismissCountDown" dismissible fade variant="warning">
                    {{ msg }}
                </b-alert>
            </b-card>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    props: {},
    name: "Login",
    data() {
        return {
            show: false,
            dismissSecs: 5,
            dismissCountDown: 0,
            msg: "",
            showDismissibleAlert: false,
            user: {
                username: "",
                password: "",
            },
        };
    },
    mounted() {

    },

    methods: {

        lang_en() {
            // i18n.locale = 'en'
            this.$i18n.locale = 'en'
        },
        lang_la() {
            //   i18n.locale = 'la'
            this.$i18n.locale = 'la'
             
        },
        onLogin() {
            //  console.log(this.$store)
            //  this.$router.push('/')
            //   this.$store.actions.commitSAuth()
            // this.$store.dispatch('setLogin');

            let login = [];

            let rep = null;
            let data = this.user;
            axios
                .post(this.$store.getters.getBaseUrl + "/login", data, {
                    "Content-Type": "application/json",
                    Authorization: "JWT",
                })
                .then((response) => {
                    //     console.log("response: ", response.data);
                    rep = response.data;
                    // do something about response
                    //   this.$store.commit("setCurrentUser",username);
                    //   this.$store.commit("setToken",response.data['TOKEN']);
                    if (rep.code == 1 ) {
                        login = rep.rows[0];
                        /*  
          login={
                    Auth_Login: true,
                    Username: "",
                    Token: "",
                    Level: "",
                  }
            */
                      

                        localStorage.removeItem("Login");
                        localStorage.setItem("Login", JSON.stringify(login));
                        this.$store.commit("setLogin", true);

                        //  console.log(this.$store.state.token);
                      //   this.$router.push('/Home')
                      
                    
                         this.$router.replace("/");
                    } else {
                        this.$bvToast.toast(rep.msg, {
                            title: `Error:`,
                            toaster: 'b-toaster-top-right',
                            solid: true,
                            appendToast: true
                        })
                    }
                })
                .catch((err) => {
                    console.error(err);
                    //alert(err)
                    // countDownChanged;
                    this.msg = err;
                    this.dismissCountDown = 5;
                });

            //let url= this.$store.getters.getBaseUrl()
        },
    },
};
</script>

<style scoped>
label {
    font-family: "Noto Sans Lao Regular";
}

.text-md-center {
    padding: 10px;
}

.images {
    margin-top: 60px;
}

.font {
    font-family: "Noto Sans Lao Regular";
}

.root {
    width: 500px;
    margin: 0 auto;
    background-color: #fff;
    padding: 30px;
    margin-top: 30px;
    border-radius: 20px;
}

.wave {
    position: fixed;
    height: 100%;
    left: 0;
    bottom: 0;
    z-index: -1;
}

input {
    border: none;
    outline: none;
    border-bottom: 1px solid #ddd;
    font-size: 1em;
    padding: 10px 0;
    margin: 25px 0 5px 0;
    width: 100%;
}

button {
    background-color: #3498db;
    padding: 10px 20px;
    margin-top: 10px;
    border: none;
    color: white;
}
</style>
